module.exports = __webpack_public_path__ + "img/gtl-logo-with-background.473cbf6c.png";